import Hotjar from "@hotjar/browser";
import { getConsent } from "./utils/consent";

let initialized = false;

const InitializeHotjar = () => {
  if (initialized || getConsent() !== true) {
    return;
  }
  const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID;
  if (!HOTJAR_ID) {
    return;
  }
  Hotjar.init(HOTJAR_ID, 6);
  initialized = true;
};

export default InitializeHotjar;
export { InitializeHotjar };
